{
   "name": "Voodoo Cards",
   "version": "0.1.1",
   "description": "The voodoo card AR",
   "source": "src/index.html",
   "scripts": {
      "start": "parcel src/index.html src/ar.html --https",
      "build": "parcel build src/index.html src/ar.html --public-url='./'",
      "deploy:dev": "npm run build && npx wrangler pages deploy dist --project-name=voodoocards --branch=dev",
      "deploy:prod": "npm run build && npx wrangler pages deploy dist --project-name=voodoocards",
      "deploy": "npm run deploy:dev"
   },
   "alias": {
      "node-fetch": "./src/vendor/node-fetch-shim.js"
   },
   "author": "Greenman",
   "license": "MIT",
   "dependencies": {
      "three": "^0.143.0"
   },
   "devDependencies": {
      "@types/three": "^0.143.0",
      "buffer": "^6.0.3",
      "gh-pages": "^3.1.0",
      "parcel": "^2.7.0",
      "process": "^0.11.10",
      "string_decoder": "^1.3.0",
      "util": "^0.12.5"
   }
}
